class ServicesAccordion extends HTMLElement {
  connectedCallback() {
    this.items = this.querySelectorAll('[data-accordion-item]');

    this.items.forEach(item => {
      item.addEventListener('click', () => {
        if (item.hasAttribute('data-active')) return;
        this.items.forEach(i => i.removeAttribute('data-active'));
        item.setAttribute('data-active', '');
      });
    });

    // On desktop: first item active. On mobile: all active.
    this.setup();
    window.addEventListener('resize', () => this.setup());
  }

  setup() {
    if (window.innerWidth >= 1024) {
      this.items.forEach(i => i.removeAttribute('data-active'));
      if (this.items[0]) this.items[0].setAttribute('data-active', '');
    } else {
      this.items.forEach(i => i.setAttribute('data-active', ''));
    }
  }
}

customElements.define('services-accordion', ServicesAccordion);
